module.exports = __webpack_public_path__ + "img/stat2.7c3e68d6.svg";